$background-color: var(--cwc-float-button-background-color, rgba(0, 0, 0, 0.2)) !default;
$shadow: var(--cwc-float-button-shadow, 0 2px 4px rgba(0, 0, 0, 0.3)) !default;
$icon-color: var(--cwc-float-button-icon-color, rgb(41, 41, 41)) !default;
$icon-size: var(--cwc-float-button-icon-size, 1.5rem) !default;
$button-size: var(--cwc-float-button-size, 2.5rem) !default;
$button-size-large: var(--cwc-float-button-size, 3.25rem) !default;

:host {
  display: flex;
  justify-content: center;
  width: $button-size;
  height: $button-size;
  border-radius: 100%;
  background-color: $background-color;
  box-shadow: $shadow;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  slot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    fill: currentColor;
    color: $icon-color;
  }

  ::slotted(*) {
    width: $icon-size;
  }
}

:host([large]) {
  width: $button-size-large;
  height: $button-size-large;
}
